import createReactComponent from '../createReactComponent';
var LightbulbOff = createReactComponent('LightbulbOff', [['path', {
  d: 'M9 18h6',
  key: 'x1upvd'
}], ['path', {
  d: 'M10 22h4',
  key: 'ceow96'
}], ['path', {
  d: 'M2 2l20 20',
  key: '48x37f'
}], ['path', {
  d: 'M8.91 14a4.61 4.61 0 00-1.41-2.5C6.23 10.23 6 9 6 8a6 6 0 01.084-1M9 2.804A6 6 0 0118 8a4.651 4.651 0 01-1.031 3',
  key: 'd3o9o3'
}]]);
export default LightbulbOff;